module.exports = __webpack_public_path__ + "static/media/microsoft-logo.3d6a2ad5.png";